import { render, staticRenderFns } from "./EnforcementRequestForm.vue?vue&type=template&id=30ae2d61"
import script from "./EnforcementRequestForm.vue?vue&type=script&lang=js"
export * from "./EnforcementRequestForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports